import { motion } from "framer-motion";
import borderGreen from "../../assets/border_green.svg";
import { cx, scrollToId } from "./helpers";

export const sectionSpacingClass = "scroll-mt-28 py-12 sm:py-16";

export function Section({ id, eyebrow, title, icon: Icon, children }) {
  return (
    <section id={id} className={sectionSpacingClass}>
      <motion.div
        initial={{ y: 16, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="grid gap-8"
      >
        <div className="flex items-start justify-between gap-6">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-theme-text-subtle">{eyebrow}</p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl tracking-tight">{title}</h2>
          </div>
          {Icon ? (
            <div className="shrink-0 rounded-2xl border border-theme-border bg-theme-surface p-3 shadow-sm">
              <Icon className="h-5 w-5 text-theme-text-muted" />
            </div>
          ) : null}
        </div>

        {children}
      </motion.div>
    </section>
  );
}

export function Card({ children, className }) {
  return (
    <div
      className={cx(
        "rounded-3xl border border-theme-border bg-theme-surface backdrop-blur-sm shadow-sm",
        className
      )}
    >
      {children}
    </div>
  );
}

export function SectionDivider() {
  return (
    <div className="py-1 sm:py-2">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-theme-border to-transparent" />
    </div>
  );
}

export function SectionDividerFlower() {
  return (
    <div className="py-1 sm:py-2">
      <img
        src={borderGreen}
        alt=""
        aria-hidden="true"
        className="mx-auto w-full max-w-[333px] opacity-90"
      />
    </div>
  );
}

export function NavPill({ label, id, active }) {
  return (
    <button
      onClick={() => scrollToId(id)}
      className={cx(
        "rounded-full px-3 py-2 text-xs tracking-wide transition",
        active ? "bg-theme-border text-theme-text" : "text-theme-text-muted hover:bg-theme-border-light"
      )}
    >
      {label}
    </button>
  );
}
